/**
 * Environment helpers — client-side detection used ONLY for honest
 * contextual labelling (e.g., the preview-only footer notice).
 *
 * This never gates functionality. It only augments copy so a
 * production build never carries "preview" labels and a preview build
 * never pretends to be production. Everything else continues to work
 * identically in both environments.
 *
 * Preview detection: the Emergent preview domain always contains the
 * `.preview.emergentagent.com` suffix (see REACT_APP_BACKEND_URL in
 * /app/frontend/.env). The production build is served from the
 * public CRA3D domain, which does not carry that suffix. We fall back
 * to `localhost` for local development so devs see the preview label.
 */
export function isPreviewEnv() {
  if (typeof window === "undefined" || !window.location) return false;
  const host = (window.location.hostname || "").toLowerCase();
  if (!host) return false;
  if (host === "localhost" || host === "127.0.0.1") return true;
  if (host.endsWith(".preview.emergentagent.com")) return true;
  if (host.endsWith(".emergent.sh")) return true;
  return false;
}
